<template>

  <div >
    <div class="layui-body" id="app-body-right">
      <div class="layadmin-tabsbody-item layui-show">
        <el-tabs type="card" :value="activeSubItem" @tab-remove="closeTab" class='content-body' @tab-click="tabClick($event)" :before-leave="handleBeforeLeave">
              <el-tab-pane v-for="item in tabs" :label="item.label" :key="item.index" :name="item.index" :closable="item.closable">            
                  <template v-if="item.label == '卡片详情' || item.label == '卡片信息'">
                    <async-component v-if="refreshFlag" :componentPath='item.component'></async-component>
                  </template>
                  <template v-else>
                    <async-component :componentPath='item.component'></async-component>
                  </template>
              </el-tab-pane>
        </el-tabs>
      </div>
    </div>


    <!-- 切换主题 -->
    <div id="LAY_adminPopupTheme" class="layui-layer layui-layer-page layui-anim ">
        <div class="layui-layer-content">
            <div class="layui-card-header">
              <span>主题切换</span>
              <span @click="hideThemePanel()"
              style="position: absolute;right: 0;width: 60px;text-align: center;cursor: pointer;">
                <i class="layui-icon layui-icon-next" style="font-size: 16px; color: #1E9FFF;"></i>  
              </span>
            </div>
            <div class="layui-card-body layadmin-setTheme">
                <ul class="layadmin-setTheme-color">
                    <li theme="theme-1" currentNavItemColor="#2f9688"
                    :class="{'theme-active':$store.state.style.currentTheme=='theme-1'}" 
                    @click="changeTheme($event)">
                        <div>
                            <div class="layadmin-setTheme-header" style="background-color: #fff;"></div>
                            <div class="layadmin-setTheme-side" style="background-color: #20222A;">
                                <div class="layadmin-setTheme-logo" style="background-color: #fff;"></div>
                            </div>
                        </div>
                    </li>
                    <li theme="theme-2" currentNavItemColor="#1e9fff" :class="{'theme-active':$store.state.style.currentTheme=='theme-2'}" @click="changeTheme($event)">
                        <div>
                            <div class="layadmin-setTheme-header" style="background-color: #fff;"></div>
                            <div class="layadmin-setTheme-side" style="background-color: #03152A;">
                                <div class="layadmin-setTheme-logo" style="background-color: #fff;"></div>
                            </div>
                        </div>
                    </li>
                    <li theme="theme-3" currentNavItemColor="#94785c" :class="{'theme-active':$store.state.style.currentTheme=='theme-3'}" @click="changeTheme($event)">
                        <div>
                            <div class="layadmin-setTheme-header" style="background-color: #fff;"></div>
                            <div class="layadmin-setTheme-side" style="background-color: #2E241B;">
                                <div class="layadmin-setTheme-logo" style="background-color: #fff;"></div>
                            </div>
                        </div>
                    </li>
                    <li theme="theme-4" currentNavItemColor="#6e456f" :class="{'theme-active':$store.state.style.currentTheme=='theme-4'}" @click="changeTheme($event)">
                        <div>
                            <div class="layadmin-setTheme-header" style="background-color: #fff;"></div>
                            <div class="layadmin-setTheme-side" style="background-color: #50314F;">
                                <div class="layadmin-setTheme-logo" style="background-color: #fff;"></div>
                            </div>
                        </div>
                    </li>
                    <li theme="theme-5" currentNavItemColor="#1E9FFF" :class="{'theme-active':$store.state.style.currentTheme=='theme-5'}" @click="changeTheme($event)">
                        <div>
                            <div class="layadmin-setTheme-header" style="background-color: #fff;"></div>
                            <div class="layadmin-setTheme-side" style="background-color: #344058;">
                                <div class="layadmin-setTheme-logo" style="background-color: #1E9FFF;"></div>
                            </div>
                        </div>
                    </li>
                    <li theme="theme-6" currentNavItemColor="#55a66c" :class="{'theme-active':$store.state.style.currentTheme=='theme-6'}"  @click="changeTheme($event)">
                        <div>
                            <div class="layadmin-setTheme-header" style="background-color: #fff;"></div>
                            <div class="layadmin-setTheme-side" style="background-color: #3A3D49;">
                                <div class="layadmin-setTheme-logo" style="background-color: #2F9688;"></div>
                            </div>
                        </div>
                    </li>
                    <li theme="theme-7" currentNavItemColor="#F78400" :class="{'theme-active':$store.state.style.currentTheme=='theme-7'}" @click="changeTheme($event)">
                        <div>
                            <div class="layadmin-setTheme-header" style="background-color: #fff;"></div>
                            <div class="layadmin-setTheme-side" style="background-color: #20222A;">
                                <div class="layadmin-setTheme-logo" style="background-color: #F78400;"></div>
                            </div>
                        </div>
                    </li>
                    <li theme="theme-8" currentNavItemColor="#AA3130" :class="{'theme-active':$store.state.style.currentTheme=='theme-8'}" @click="changeTheme($event)">
                        <div>
                            <div class="layadmin-setTheme-header" style="background-color: #fff;"></div>
                            <div class="layadmin-setTheme-side" style="background-color: #28333E;">
                                <div class="layadmin-setTheme-logo" style="background-color: #AA3130;"></div>
                            </div>
                        </div>
                    </li>
                    <li theme="theme-9" currentNavItemColor="#2f9688" :class="{'theme-active':$store.state.style.currentTheme=='theme-9'}" @click="changeTheme($event)">
                        <div>
                            <div class="layadmin-setTheme-header" style="background-color: #fff;"></div>
                            <div class="layadmin-setTheme-side" style="background-color: #24262F;">
                                <div class="layadmin-setTheme-logo" style="background-color: #3A3D49;"></div>
                            </div>
                        </div>
                    </li>
                    <li theme="theme-10" currentNavItemColor="#2f9688" :class="{'theme-active':$store.state.style.currentTheme=='theme-10'}" @click="changeTheme($event)">
                        <div>
                            <div class="layadmin-setTheme-header" style="background-color: #2F9688;"></div>
                            <div class="layadmin-setTheme-side" style="background-color: #28333E;">
                                <div class="layadmin-setTheme-logo" style="background-color: #28333E;"></div>
                            </div>
                        </div>
                    </li>
                    <li theme="theme-11" currentNavItemColor="#1e9fff" :class="{'theme-active':$store.state.style.currentTheme=='theme-11'}" @click="changeTheme($event)">
                        <div>
                            <div class="layadmin-setTheme-header" style="background-color: #1E9FFF;"></div>
                            <div class="layadmin-setTheme-side" style="background-color: #344058;">
                                <div class="layadmin-setTheme-logo" style="background-color: #0085E8;"></div>
                            </div>
                        </div>
                    </li>
                    <li theme="theme-12" currentNavItemColor="#2f9688" :class="{'theme-active':$store.state.style.currentTheme=='theme-12'}" @click="changeTheme($event)">
                        <div>
                            <div class="layadmin-setTheme-header" style="background-color: #393D49;"></div>
                            <div class="layadmin-setTheme-side" style="background-color: #03152A;">
                                <div class="layadmin-setTheme-logo" style="background-color: #03152A;"></div>
                            </div>
                        </div>
                    </li>
                    <li theme="theme-13" currentNavItemColor="#6e456f" :class="{'theme-active':$store.state.style.currentTheme=='theme-13'}" @click="changeTheme($event)">
                        <div>
                            <div class="layadmin-setTheme-header" style="background-color: #50314F;"></div>
                            <div class="layadmin-setTheme-side" style="background-color: #50314F;">
                                <div class="layadmin-setTheme-logo" style="background-color: #50314F;"></div>
                            </div>
                        </div>
                    </li>
                    <li theme="theme-14" currentNavItemColor="#AA3130" :class="{'theme-active':$store.state.style.currentTheme=='theme-14'}" @click="changeTheme($event)">
                        <div>
                            <div class="layadmin-setTheme-header" style="background-color: #AA3130;"></div>
                            <div class="layadmin-setTheme-side" style="background-color: #28333E;">
                                <div class="layadmin-setTheme-logo" style="background-color: #28333E;"></div>
                            </div>
                        </div>
                    </li>
                    <li theme="theme-15" currentNavItemColor="#2f9688" :class="{'theme-active':$store.state.style.currentTheme=='theme-15'}" @click="changeTheme($event)">
                        <div>
                            <div class="layadmin-setTheme-header" style="background-color: #009688;"></div>
                            <div class="layadmin-setTheme-side" style="background-color: #28333E;">
                                <div class="layadmin-setTheme-logo" style="background-color: #009688;"></div>
                            </div>
                        </div>
                    </li>
                    <li theme="theme-16" currentNavItemColor="#2f9688" :class="{'theme-active':$store.state.style.currentTheme=='theme-16'}" @click="changeTheme($event)">
                        <div>
                            <div class="layadmin-setTheme-header" style="background-color: #fff;"></div>
                            <div class="layadmin-setTheme-side" style="background-color: #20222A;">
                                <div class="layadmin-setTheme-logo" style="background-color: #20222A;"></div>
                            </div>
                        </div>
                    </li>
                    <li theme="theme-17" currentNavItemColor="#2f9688" :class="{'theme-active':$store.state.style.currentTheme=='theme-17'}" @click="changeTheme($event)">
                        <div>
                            <div class="layadmin-setTheme-header" style="background-color: #fff;"></div>
                            <div class="layadmin-setTheme-side" style="background-color: #03152A;">
                                <div class="layadmin-setTheme-logo" style="background-color: #03152A;"></div>
                            </div>
                        </div>
                    </li>
                    <li theme="theme-18" currentNavItemColor="#94785c" :class="{'theme-active':$store.state.style.currentTheme=='theme-18'}" @click="changeTheme($event)">
                        <div>
                            <div class="layadmin-setTheme-header" style="background-color: #fff;"></div>
                            <div class="layadmin-setTheme-side" style="background-color: #2E241B;">
                                <div class="layadmin-setTheme-logo" style="background-color: #2E241B;"></div>
                            </div>
                        </div>
                    </li>
                    <li theme="theme-19" currentNavItemColor="#009688" :class="{'theme-active':$store.state.style.currentTheme=='theme-19'}" @click="changeTheme($event)">
                        <div>
                            <div class="layadmin-setTheme-header" style="background-color: #fff;"></div>
                            <div class="layadmin-setTheme-side" style="background-color: #344058;">
                                <div class="layadmin-setTheme-logo" style="background-color: #fff;"></div>
                            </div>
                        </div>
                    </li>
                    <li theme="theme-20" currentNavItemColor="#009688" :class="{'theme-active':$store.state.style.currentTheme=='theme-20'}" @click="changeTheme($event)">
                        <div>
                            <div class="layadmin-setTheme-header" style="background-color: #fff;"></div>
                            <div class="layadmin-setTheme-side" style="background-color: #344058;">
                                <div class="layadmin-setTheme-logo" style="background-color: #344058;"></div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>

        </div>
        <span class="layui-layer-setwin">
        </span>
        <span class="layui-layer-resize">
        </span>
    </div>
    <!-- 切换主题 -->


  </div>

</template>

<script>
// import AdminIndex from "../AdminIndex";
import { mapActions, mapState,mapMutations } from "vuex";
import AsyncComponent from "@/views/home/AsyncComponent";

export default {
  components: {
    // AdminIndex,
    AsyncComponent
  },
  data(){
    return {
      refreshFlag: true
    }
  },
  computed: {
    ...mapState("menu", {
      tabs: "tabs",
      activeSubItem: "activeSubItem"
    })
  },
  methods: {
    ...mapActions("menu", {
      closeTab: "closeTab",
      switchTab:"switchTab"
    }),

    tabClick(e){
      this.switchTab(e.name)
    },
    handleBeforeLeave(activeName, oldActiveName){
      if(this.$store.state.menu.fromPage == 'cardMgt' || this.$store.state.menu.fromPage == 'cardList' || this.$store.state.menu.fromPage == 'orderMgt'){
        this.refreshFlag = false
      }
      this.$nextTick(() => {
        this.refreshFlag = true;
      })
    },
    //切换主题
    changeTheme(e){
      let theme = e.currentTarget.getAttribute("theme");
      let currentNavItemColor = e.currentTarget.getAttribute("currentNavItemColor");
      this.$store.commit('style/setCurrentNavItemColor', currentNavItemColor);
      this.$store.commit('style/setCurrentTheme', theme);
    },

    //收起主题面板
    hideThemePanel(){
        document.getElementById('LAY_adminPopupTheme').style.width ="0px";
    },
  },
  
  mounted(){

  },
};
</script>
<style lang="less" scoped>

*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.content-body {
  height: 100%;
}

.layadmin-view-xs #app-body-right{
    left: 210px;
    top: 70px;
    right: 15px;
    transition: all .3s;


    background: #fff;
    border-radius: 3px;
    padding: 10px;
    box-shadow: 0 0 8px rgba(0,0,0,.15);


    -ms-overflow-style: none; //IE 10+
    overflow: -moz-scrollbars-none; //Firefox
}

#app-body-right::-webkit-scrollbar {
    display: none; //Safari and Chrome
}

.layadmin-view-xs.layadmin-side-shrink{
    *{
        transition: all .3s;
    }

    #app-body-right{
        left: 55px;
    }
}

.layadmin-view-sm.layadmin-side-shrink{
    #app-body-right{
        left: 3px;
        padding-right: 3px;
    }

    
}



/***  主题切换面板  ***/

#LAY_adminPopupTheme{
    position:absolute;
    z-index: 1000; 
    width: 0px; 
    height: calc(100% - 60px); 
    top: 60px; 
    left: auto; 
    right: 0;
    background: #fff;
    box-shadow: 0 5px 10px rgba(0,0,0,.5);
    transition: .3s;


    >div{
      overflow: hidden;
    }
}

.layui-card-header{
  padding-left: 13px;
}

.layadmin-setTheme-color {
    width: 330px;
    padding-left: 3px;
    font-size: 0;
    border: 1px solid #f7f7f7;
}



.layadmin-setTheme-color li {
    border: 1px solid #fff;
    display: inline-block;
    vertical-align: top;
    padding: 10px;
    transition: .3s;

    >div{
        position: relative;
        width: 80px;
        height: 50px;
        padding: 10px;
        background-color: #f2f2f2;
        cursor: pointer;
        font-size: 12px;
        color: #666;
        border: 1px solid #f2f2f2;
    }
}


.layadmin-setTheme-color li:hover{
  border: 1px solid #2f9688;
  transition: .8s;
}

.layadmin-setTheme-color .theme-active {
  border: 1px solid #2f9688;
  transition: .8s;
}

.layadmin-setTheme-header {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    z-index: 10;
    height: 10px;
    border-right: 1px solid #f2f2f2;
}

.layadmin-setTheme-header, .layui-layout-admin .layui-footer {
    background-color: #fff;
}

.layadmin-setTheme-side {
    position: absolute;
    left: 0;
    top: 0;
    width: 20px;
    height: 100%;
    z-index: 11;
    box-shadow: 1px 0 2px 0 rgba(0,0,0,.05);
}

.layadmin-setTheme-side, .layui-side-menu {
    background-color: #20222A;
    color: #fff;
}

.layadmin-setTheme-logo {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 10px;
    box-shadow: 0 1px 2px 0 rgba(0,0,0,.15);
}



/***  主题切换面板  end ***/
</style>


